import { DataGrid, GridAutosizeOptions, GridColDef, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport, GridToolbarFilterButton, useGridApiRef } from '@mui/x-data-grid';
import Typography from '@mui/material/Typography';
import { Avatar, Box, Button, Card, CardContent, Chip, Modal, Stack, Tooltip, darken, lighten, styled } from '@mui/material';
import { GridToolbar } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { useAppDispatch } from '../../store';
import { logOut } from '../../utils/logOut';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { log } from 'console';
import React from 'react';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import AudioFragment from '../../utils/AudioFragment';
import NoDataOverlay from '../../utils/NoDataOverlay';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import TranslatedText, { useTranslation } from '../../utils/Translate';
import { title } from 'process';
import { RepeatcallsDecode, targetActiveTransfersDecode, TerminalstatusesDecode, TimeDecode } from '../../utils/prepareJSON';
import { convertCompilerOptionsFromJson } from 'typescript';
import { resolve } from 'path';
import { rejects } from 'assert';
import { playtexttostring } from '../../utils/ConversationTemplateSetupHelper';
import { decode } from 'html-entities';
import { useSnackbar } from '../../utils/SnackbarContext';



function Table({ rows, page }: any) {

    const [fullscreen, setFullscreen] = useState(false)
    const [data, setData] = useState(rows)
    const [convertedHeaders, setConvertedHeaders] = useState<any>([])
    const [campaignsList, setCampaignsList] = useState<any>([])
    const dispatch = useAppDispatch()
    const language = useSelector((state: any) => state.auth.authData.language);
    console.log(page);
    const [columns, setColumns] = useState<GridColDef[]>([]);
    const [openDeleteModal, setOpenDeleteModal] = React.useState(false);
    const handleDeleteModalOpen = useCallback((id: any) => {
        setOpenDeleteModal(id);
    }, []);
    const handleDeleteModalClose = useCallback(() => {
        setOpenDeleteModal(false);
    }, []);

    const { showSnackbar } = useSnackbar();

    const Modalstyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        minWidth: 400,
        maxWidth: 800,
        with: '40%',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
    };


    //fullscreen styles
    const fullscreenStyles = {
        position: "absolute",
        zIndex: 1100,
        top: 0,
        left: 0,
        bgcolor: '#FFF',
        "& .MuiDataGrid-footerContainer": {
            justifyContent: "flex-start",
            display: 'none'
        },
        height: '100%',
        minWidth: '100%'
    }

    //Get max length from table data to make ceil sizes

    const maxLengths = useMemo(() => {
        return data.reduce((max: any, obj: any) => {
            Object.keys(obj).forEach(key => {
                if (typeof obj[key] === 'string') {
                    const length = obj[key].length;
                    max[key] = Math.max(max[key] || 0, length);
                }
            });
            return max;
        }, {});
    }, [data]);





    useEffect(() => {

        if (page == 'campaign') {
            getCampaigns()
        }


        data[0] && setConvertedHeaders(Object.keys(data[0]).map((el) => {
            if (el == 'partnerbankcode') {
                return 'PARTNER CODE';
            }
            else if (el == 'cgdatetoprocess') {
                return 'NEXT CONTACT DATE';
            }
            else if (el == 'branchname') {
                return 'BRANCH';
            }
            else if (el == 'officename') {
                return 'OFFICE';
            }
            else if (el == 'isclosed') {
                return 'STATUS';
            }
            else if (el == 'leaddate') {
                return 'LEAD DATE';
            }
            else if (el == 'mobilephone') {
                return 'PHONE NUMBER';
            }
            else if (el == 'id') {
                return 'ID';
            }
            else if (el == 'clientid') {
                return 'CUSTOMER ID';
            }
            else if (el == 'customerlead') {
                return 'ID';
            }
            else if (el == 'lastname') {
                return 'LAST NAME';
            }
            else if (el == 'firstname') {
                return 'NAME';
            }
            else if (el == 'middlename') {
                return 'SURNAME';
            }
            else if (el == 'conversationtemplatecode') {
                return 'CONVERSATION TEMPLATE';
            }
            else if (el == 'firstcall') {
                return 'DATE OF THE FIRST CALL';
            }
            else if (el == 'lastcall') {
                return 'LAST CALL DATE';
            }
            else if (el == 'countcalls') {
                return 'NUMBER OF CALLS';
            }
            else if (el == 'countconversations') {
                return 'NUMBER OF CONVERSATIONS';
            }
            else if (el == 'durationconversationsmin') {
                return 'CHARGED TIME, MIN';
            }
            else if (el == 'leadgroupcode') {
                return 'CODE';
            }
            else if (el == 'leadgroupname') {
                return 'NAME';
            }
            else if (el == 'calldate') {
                return 'CALL DATE';
            }
            else if (el == 'callstatus') {
                return 'CALL STATUS';
            }
            else if (el == 'campaigncode') {
                return 'CAMPAIGN CODE';
            }
            else if (el == 'field1name') {
                return 'FIELD 1 NAME';
            }
            else if (el == 'field1value') {
                return 'FIELD 1 VALUE';
            }
            else if (el == 'field1correct') {
                return 'FIELD 1 CORRECT';
            }
            else if (el == 'field2name') {
                return 'FIELD 2 NAME';
            }
            else if (el == 'field2value') {
                return 'FIELD 2 VALUE';
            }
            else if (el == 'field2correct') {
                return 'FIELD 2 CORRECT';
            }
            else if (el == 'countleads') {
                return 'COUNT LEADS';
            }
            else if (el == 'evalerror') {
                return 'MESSAGE';
            }
            else if (el == 'conversationtemplatename') {
                return 'NAME';
            }
            else if (el == 'showsetuptopartner') {
                return 'SHOW SETUP TO PARTNER';
            }
            else if (el == 'recognitionvendor') {
                return 'RECOGNITION VENDOR';
            }
            else if (el == 'voicecloningvendor') {
                return 'VOICE CLONING VENDOR';
            }
            else if (el == 'voicecode') {
                return 'VOICE CODE';
            }
            else if (el == 'pitchprerecorded') {
                return 'PRE-RECORDED VOICE TONE';
            }
            else if (el == 'prerecordedvoicename') {
                return 'PRE-RECORDED VOICE NAME';
            }
            else if (el == 'tempoprerecorded') {
                return 'PRE-RECORDED VOICE SPEED';
            }
            else if (el == 'backgroundsoundcode') {
                return 'BACKGROUND SOUND CODE';
            }
            else if (el == 'examplesoundcode') {
                return 'EXAMPLE (FREQUENCY DISTRIBUTION AND VOLUME) FOR VOICE SYNTHESIS';
            }
            else if (el == 'conversationwhen') {
                return 'CONVERSATION START';
            }
            else if (el == 'endtime') {
                return 'CONVERSATION END';
            }
            else if (el == 'calleridname') {
                return 'CALLER NAME';
            }
            else if (el == 'calleridnum') {
                return 'CALLER NUM';
            }
            else if (el == 'commandwhen') {
                return 'COMMAND TIME';
            }
            else if (el == 'shortdescription') {
                return 'SHORT DESCRIPTION';
            }
            else if (el == 'templatepart') {
                return 'TYPE';
            }
            else if (el == 'recordnumber') {
                return 'COMMAND NUMBER';
            }
            else if (el == 'lastinputvalue') {
                return 'INPUT ACCEPTED BY THE COMMAND';
            }
            else if (el == 'conversationhistoryfields') {
                return 'FIELDS SET BY THE COMMAND';
            }
            else if (el == 'datetimeproduced') {
                return 'CREATION DATE';
            }
            else if (el == 'voicename') {
                return 'VOICE';
            }
            else if (el == 'ip') {
                return 'IP Address';
            }
            else return el.toUpperCase(); // Преобразование всех остальных значений в заглавные буквы
        }));



    }, [data])











    const accesslevel = useSelector(
        (state: any) => state.auth.authData.accesslevel
    )


    //delete func for prerecorded audio snippets
    async function DeletePrerecordedAudio(id: any) {
        try {
            const response = await axios.delete('https://cardgarantsales.com/restapi/prerecordedspeech/' + id, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })
            setData(data.filter((row: any) => row.id !== id))
        } catch (error: any) {
            console.log(error);
            if (error.code === "ERR_BAD_REQUEST") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }


    //delete func for synth audio snippets
    async function DeleteSynthAudio(id: any) {
        try {
            const response = await axios.delete('https://cardgarantsales.com/restapi/synthesizedspeech/' + id, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })
            setData(data.filter((row: any) => row.id !== id))
        } catch (error: any) {
            console.log(error);
            if (error.code === "ERR_BAD_REQUEST") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }


    async function handleDelete(id: any) {
        if (page == 'synthaudiofragment') {
            DeleteSynthAudio(id)
        }
        else if (page == 'prerecordedaudiosnippet') {
            DeletePrerecordedAudio(id)
        }
        else {
            try {
                const response = await axios.delete(`https://cardgarantsales.com/restapi/${page}/` + id, {
                    headers: {
                        'Content-Type': 'application/json',
                        "Authorization": "Bearer " + localStorage.getItem('access_token')
                    },
                })
                setData(data.filter((row: any) => row.id !== id))
            } catch (error: any) {
                console.log(error);
                if (error.code === "ERR_BAD_REQUEST") {
                    logOut(dispatch)
                }
                else if (error.code === "ERR_NETWORK") {
                    showSnackbar('ERROR NETWORK', 'error')
                }
            }
        }

        handleDeleteModalClose()
    }





    //Convert to clear rows 
    function convertCells(data: any) {

        return data.map((row: any) => {
            if (page === 'settingsupconversationtemplate') {
                return {
                    ...row,
                    'templatepart': row.templatepart === '1' ? 'Background' : row.templatepart === '2' ? 'Conversation' : "Call managment",
                    'enabled': row.enabled === '1' ? 'Yes' : 'No',
                    'commanddetails': row.commanddetails ? Object.keys(JSON.parse(row.commanddetails))[0] == 'play' ? playtexttostring(JSON.parse(row.commanddetails).play.playtext) : '' : ''
                }
            }
            if (page === 'conversationtemplate') {
                return {
                    ...row,
                    'showsetuptopartner': row.showsetuptopartner === '1' ? 'Yes' : 'No'
                }
            }
            if (page === 'wordgroup') {
                return {
                    ...row,
                    'showsetuptopartner': row.showsetuptopartner === '1' ? 'Yes' : 'No',
                    'partnerbankcode': row.partnerbankcode == null ? 'General' : row.partnerbankcode,
                    'conversationtemplatecode': row.conversationtemplatecode == null ? 'General' : row.conversationtemplatecode,
                }
            }

            if (page === 'conversationdetail') {
                return {
                    ...row,
                    'templatepart': row.templatepart === '1' ? 'Background' : 'Conversation',
                }
            }
            if (page === 'contact') {
                return {
                    ...row,
                    'isclosed': row.isclosed === '0' ? 'Open' : 'Closed'
                }
            }
            if (page === 'did') {
                return {
                    ...row,
                    'enabled': row.enabled === '0' ? 'No' : 'Yes'
                }
            }
            if (page === 'campaign') {

                const statusMapping: any = {
                    "0": 'Stopped',
                    "1": 'Launched',
                    "2": 'Stopped by a robot - calls do not go through!',
                    "3": 'Launched - no contacts',
                    "4": 'Launched - break'
                };


                return {
                    ...row,
                    'status': statusMapping[row.status],
                    'removefromleadgroup': row.removefromleadgroup == '1' ? 'Remove' : 'Keep',
                    'emails': row.emails ? JSON.parse(row.emails).join(', ') : '',
                    'targetactivetransfers': targetActiveTransfersDecode(row.targetactivetransfers != null ? row.targetactivetransfers : { "campaigns": [], "limit": "" }, campaignsList),
                    'maxactivetransfers': targetActiveTransfersDecode(row.maxactivetransfers != null ? row.maxactivetransfers : { "campaigns": [], "limit": "" }, campaignsList),
                    'campaignactivetime': TimeDecode(row.campaignactivetime),
                    'clientactivetime': TimeDecode(row.clientactivetime),
                    'repeatcalls': RepeatcallsDecode(row.repeatcalls),
                    'newleadsperdaylimit': JSON.parse(row.newleadsperdaylimit)['limit'],
                    'terminalstatuses': TerminalstatusesDecode(row.terminalstatuses),

                }
            }
            else return row

        })
    }

    async function getCampaigns(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/campaign`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            if (response.data !== null) {
                if (typeof (response.data) === 'object') {
                    const convertedList = response.data.reduce((acc: any, item: any) => {
                        acc[item.id] = item.campaigncode;
                        return acc;
                    }, {});
                    setCampaignsList(convertedList)
                    return convertedList

                }
                else showSnackbar('ERROR: INVALID SERVER RESPONSE', 'error')

            }

        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }







    const getBackgroundColor = (color: string, mode: string) =>
        mode === 'dark' ? darken(color, 0.7) : lighten(color, 0.7);

    const getHoverBackgroundColor = (color: string, mode: string) =>
        mode === 'dark' ? darken(color, 0.6) : lighten(color, 0.6);

    const getSelectedBackgroundColor = (color: string, mode: string) =>
        mode === 'dark' ? darken(color, 0.5) : lighten(color, 0.5);

    const getSelectedHoverBackgroundColor = (color: string, mode: string) =>
        mode === 'dark' ? darken(color, 0.4) : lighten(color, 0.4);

    const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
        '& .row-color--blue': {
            backgroundColor: getBackgroundColor(theme.palette.info.main, theme.palette.mode),
            '&:hover': {
                backgroundColor: getHoverBackgroundColor(
                    theme.palette.info.main,
                    theme.palette.mode,
                ),
            },
            '&.Mui-selected': {
                backgroundColor: getSelectedBackgroundColor(
                    theme.palette.info.main,
                    theme.palette.mode,
                ),
                '&:hover': {
                    backgroundColor: getSelectedHoverBackgroundColor(
                        theme.palette.info.main,
                        theme.palette.mode,
                    ),
                },
            },
        },
        '& .row-color--green': {
            backgroundColor: getBackgroundColor(
                theme.palette.success.main,
                theme.palette.mode,
            ),
            '&:hover': {
                backgroundColor: getHoverBackgroundColor(
                    theme.palette.success.main,
                    theme.palette.mode,
                ),
            },
            '&.Mui-selected': {
                backgroundColor: getSelectedBackgroundColor(
                    theme.palette.success.main,
                    theme.palette.mode,
                ),
                '&:hover': {
                    backgroundColor: getSelectedHoverBackgroundColor(
                        theme.palette.success.main,
                        theme.palette.mode,
                    ),
                },
            },
        },
        '& .row-color--yellow': {
            backgroundColor: getBackgroundColor(
                theme.palette.warning.main,
                theme.palette.mode,
            ),
            '&:hover': {
                backgroundColor: getHoverBackgroundColor(
                    theme.palette.warning.main,
                    theme.palette.mode,
                ),
            },
            '&.Mui-selected': {
                backgroundColor: getSelectedBackgroundColor(
                    theme.palette.warning.main,
                    theme.palette.mode,
                ),
                '&:hover': {
                    backgroundColor: getSelectedHoverBackgroundColor(
                        theme.palette.warning.main,
                        theme.palette.mode,
                    ),
                },
            },
        },
        '& .row-color--red': {
            backgroundColor: getBackgroundColor(
                theme.palette.error.main,
                theme.palette.mode,
            ),
            '&:hover': {
                backgroundColor: getHoverBackgroundColor(
                    theme.palette.error.main,
                    theme.palette.mode,
                ),
            },
            '&.Mui-selected': {
                backgroundColor: getSelectedBackgroundColor(
                    theme.palette.error.main,
                    theme.palette.mode,
                ),
                '&:hover': {
                    backgroundColor: getSelectedHoverBackgroundColor(
                        theme.palette.error.main,
                        theme.palette.mode,
                    ),
                },
            },
        },
    }));

    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarExport />

                <Button
                    onClick={() => setFullscreen(!fullscreen)}
                    variant={"text"}
                    size="small"
                    style={{ marginLeft: 0 }}
                >
                    <Box display={'flex'} alignItems={'center'}>
                        {fullscreen ? <FullscreenExitIcon color="primary" /> : <FullscreenIcon color="primary" />}
                        <TranslatedText text={'fullscreen'} />
                    </Box>
                </Button>
            </GridToolbarContainer>
        );
    }

    const localeText = {
        toolbarColumns: useTranslation('Columns'),
        toolbarFilters: useTranslation('Filters'),
        toolbarExport: useTranslation('Export'),
        columnsPanelTextFieldLabel: useTranslation('Find column'),
        columnsPanelTextFieldPlaceholder: useTranslation('Column name'),
        columnsPanelShowAllButton: useTranslation('Show all'),
        columnsPanelHideAllButton: useTranslation('Hide all'),
        filterPanelAddFilter: useTranslation('Add filter'),
        filterPanelDeleteIconLabel: useTranslation('Delete'),
        filterPanelOperator: useTranslation('Operator'),
        filterPanelOperatorAnd: useTranslation('And'),
        filterPanelOperatorOr: useTranslation('Or'),
        filterPanelColumns: useTranslation('Columns'),
        filterPanelInputLabel: useTranslation('Value'),
        filterOperatorContains: useTranslation('contains'),
        filterOperatorEquals: useTranslation('equals'),
        filterOperatorStartsWith: useTranslation('starts with'),
        filterOperatorEndsWith: useTranslation('ends with'),
        filterOperatorIs: useTranslation('is'),
        filterOperatorNot: useTranslation('is not'),
        filterOperatorAfter: useTranslation('is after'),
        filterOperatorOnOrAfter: useTranslation('is on or after'),
        filterOperatorBefore: useTranslation('is before'),
        filterOperatorOnOrBefore: useTranslation('is on or before'),
        filterOperatorIsEmpty: useTranslation('is empty'),
        filterOperatorIsNotEmpty: useTranslation('is not empty'),
        filterOperatorIsAnyOf: useTranslation('is any of'),
        toolbarExportCSV: useTranslation('Download CSV'),
        toolbarExportPrint: useTranslation('Print'),
        columnMenuSortAsc: useTranslation('Sort by Ascending'),
        columnMenuSortDesc: useTranslation('Sort by Descending'),
        columnMenuFilter: useTranslation('Filter'),
        columnMenuHideColumn: useTranslation('Hide column'),
        columnMenuShowColumns: useTranslation('Show columns')
    };

    const apiRef = useGridApiRef();

    const autosizeOptions: GridAutosizeOptions = {
        includeOutliers: true,
        includeHeaders: true,
    };



    const autosize = React.useCallback(() => {
        // Используем setTimeout, чтобы отложить выполнение autosizeColumns
        setTimeout(() => {
            apiRef.current.autosizeColumns(autosizeOptions);
            console.log('Autosize выполнен');
        }, 0);
    }, [data]);

    useEffect(() => {
        if (data.length > 0) {
            const timer = setTimeout(autosize, 100);
            return () => clearTimeout(timer);
        }
    }, [data, autosize]);



    console.log(data);
    return (
        <>
            {/* <Button onClick={() => apiRef.current.autosizeColumns(autosizeOptions)}>
                Autosize Columns
            </Button> */}
            {data.length > 0 ? (
                <StyledDataGrid
                    sx={fullscreen ? fullscreenStyles : {
                        "& .MuiDataGrid-footerContainer": {
                            justifyContent: "flex-start",
                            display: 'none'
                        },
                        height: '100%',

                    }}
                    apiRef={apiRef}
                    localeText={localeText}
                    // rowBufferPx={500}
                    // autosizeOptions={autosizeOptions}

                    disableVirtualization
                    disableRowSelectionOnClick
                    rows={convertCells(data)}
                    getRowHeight={() => 'auto'}
                    density="compact"
                    getRowId={(row) => page.includes('report') || page === 'calls' || page === 'optimizationtemplate' ? data.indexOf(row) : row.id}
                    slots={{ toolbar: CustomToolbar }}
                    getRowClassName={(params) => {
                        if (page === 'prerecordedaudiosnippet') {
                            if ((params.row.audiolength === null || params.row.audiolength === '0' || params.row.audiolength === '0.0') && (params.row.transcript != '' && params.row.transcript != null)) {
                                return 'row-color--red'
                            }
                            if ((params.row.audiolength === null || params.row.audiolength === '0' || params.row.audiolength === '0.0') && (params.row.transcript == '' || params.row.transcript === null)) {
                                return 'row-color--yellow'
                            }
                            if ((params.row.audiolength !== null || params.row.audiolength != '0' || params.row.audiolength != '0.0')) {
                                return 'row-color--green'
                            }
                        }
                        if (page === 'settingsupconversationtemplate') {
                            if (((Math.floor(params.row.recordnumber / 1000)) % 2 === 0)) {
                                return 'row-color--green'
                            }
                            else {
                                return 'row-color--blue'
                            }
                        }
                        return ''
                    }}
                    slotProps={{
                        toolbar: {
                            printOptions: { disableToolbarButton: true },

                            csvOptions: { allColumns: true, delimiter: ';', utf8WithBom: true }

                        }
                    }}
                    //Render table data
                    columns={
                        !page.includes('report') && page !== 'calls' && page !== 'conversation' && page !== 'prerecordedaudiosnippet' && page !== 'synthaudiofragment' && page !== 'conversationdetail' && page !== 'settingsupconversationtemplate' && page !== 'optimizationtemplate' && page !== 'wordgroup' ? [
                            {
                                field: "EDIT",
                                headerName: '',
                                disableExport: true,
                                // valueFormatter: ({ value }) => `${value * 100}%`,
                                renderCell: (el: any) => (
                                    (el.row.showsetuptopartner !== '0' || accesslevel === '5') && <Link to={`/${page}?id=${el.id}&type=edit`}>
                                        <Button
                                            onClick={() => console.log(el)}
                                            variant={"text"}
                                            size="small"
                                            style={{ marginLeft: 0 }}
                                        >
                                            <TranslatedText text={'Edit'} />
                                        </Button>
                                    </Link>
                                ),
                                minWidth: 100,
                            },
                            ...Object.keys(data[0]).map((key, i) => {
                                return ({
                                    field: key,
                                    headerName: "",
                                    renderHeader: () => convertedHeaders[i] ? <TranslatedText text={convertedHeaders[i]} /> : key,
                                    // width: maxLengths[key] === undefined ? 200 : maxLengths[key] * 15,
                                    // minWidth: convertedHeaders[i] ? convertedHeaders[i].length * 14 : key.length * 14
                                })
                            })
                        ] : page == 'prerecordedaudiosnippet' ?
                            [
                                {
                                    field: "EDIT",
                                    disableExport: true,
                                    // valueFormatter: ({ value }) => `${value * 100}%`,
                                    renderCell: (el: any) => (
                                        (el.row.showsetuptopartner !== '0' || accesslevel === '5') && <Link to={`/${page}?id=${el.id}&type=edit`}>
                                            <Button
                                                onClick={() => console.log(el)}
                                                variant={"text"}
                                                size="small"
                                                style={{ marginLeft: 0 }}
                                            >
                                                <TranslatedText text="Edit" />
                                            </Button>
                                        </Link>
                                    ),
                                    width: 82
                                },
                                {
                                    field: "COPY",
                                    disableExport: true,
                                    // valueFormatter: ({ value }) => `${value * 100}%`,
                                    renderCell: (el: any) => (
                                        (el.row.showsetuptopartner !== '0' || accesslevel === '5') && <Link to={`/${page}?id=${el.id}&type=copy`}>
                                            <Button
                                                onClick={() => console.log(el)}
                                                variant={"text"}
                                                size="small"
                                                style={{ marginLeft: 0 }}
                                            >
                                                <TranslatedText text="Copy" />
                                            </Button>
                                        </Link>
                                    ),
                                    width: 82
                                },
                                {
                                    field: "DELETE",
                                    disableExport: true,
                                    // valueFormatter: ({ value }) => `${value * 100}%`,
                                    renderCell: (el: any) => (
                                        <Button variant="text" size="small" onClick={() => handleDeleteModalOpen(el.id)}>
                                            <TranslatedText text="DELETE" />
                                        </Button>
                                    ),
                                    width: 82
                                },
                                {
                                    field: "AUDIO",
                                    disableExport: true,
                                    // valueFormatter: ({ value }) => `${value * 100}%`,
                                    renderCell: (el: any) => {
                                        return (el.row.audiolength !== null && el.row.audiolength !== '0.0' && el.row.audiolength !== '0') && <AudioFragment id={el.id} />
                                    },
                                    width: 350
                                },
                                ...Object.keys(data[0]).map((key, i) => ({
                                    field: key,
                                    renderHeader: () => convertedHeaders[i] ? <TranslatedText text={convertedHeaders[i]} /> : key,
                                    width: maxLengths[key] === undefined ? 200 : maxLengths[key] * 15,
                                    minWidth: key.length * 14
                                }))
                            ]
                            :
                            page == 'synthaudiofragment' ?
                                [
                                    {
                                        field: "EDIT",
                                        disableExport: true,
                                        // valueFormatter: ({ value }) => `${value * 100}%`,
                                        renderCell: (el: any) => (
                                            (el.row.showsetuptopartner !== '0' || accesslevel === '5') && <Link to={`/${page}?id=${el.id}&type=edit`}>
                                                <Button
                                                    onClick={() => console.log(el)}
                                                    variant={"text"}
                                                    size="small"
                                                    style={{ marginLeft: 0 }}
                                                >
                                                    <TranslatedText text="Edit" />
                                                </Button>
                                            </Link>
                                        ),
                                        width: 82
                                    },
                                    {
                                        field: "RESYNTHESIZE",
                                        disableExport: true,
                                        // valueFormatter: ({ value }) => `${value * 100}%`,
                                        renderCell: (el: any) => (
                                            (el.row.showsetuptopartner !== '0' || accesslevel === '5') && <Link to={`/${page}?id=${el.id}&type=copy`}>
                                                <Button
                                                    onClick={() => console.log(el)}
                                                    variant={"text"}
                                                    size="small"
                                                    style={{ marginLeft: 0 }}
                                                >
                                                    <TranslatedText text="Resynthesize" />
                                                </Button>
                                            </Link>
                                        ),
                                        width: 82
                                    },
                                    {
                                        field: "DELETE",
                                        disableExport: true,
                                        // valueFormatter: ({ value }) => `${value * 100}%`,
                                        renderCell: (el: any) => (
                                            <Button variant="text" size="small" onClick={() => handleDeleteModalOpen(el.id)}>
                                                <TranslatedText text="DELETE" />
                                            </Button>
                                        ),
                                        width: 82
                                    },
                                    {
                                        field: "AUDIO",
                                        disableExport: true,
                                        // valueFormatter: ({ value }) => `${value * 100}%`,
                                        renderCell: (el: any) => {
                                            return (el.row.audiolength !== null && el.row.audiolength !== '0.0' && el.row.audiolength !== '0') && <AudioFragment id={el.id} type={'synthesizedspeech'} />
                                        },
                                        width: 350
                                    },
                                    ...Object.keys(data[0]).map((key, i) => ({
                                        field: key,
                                        renderHeader: () => convertedHeaders[i] ? <TranslatedText text={convertedHeaders[i]} /> : key,
                                        width: maxLengths[key] === undefined ? 200 : maxLengths[key] * 15,
                                        minWidth: key.length * 14
                                    }))
                                ]
                                :
                                page == 'conversationdetail' ?
                                    [
                                        {
                                            field: "ALL CURRENT FIELDS",
                                            disableExport: true,
                                            // valueFormatter: ({ value }) => `${value * 100}%`,
                                            renderCell: (el: any) => (
                                                (el.row.showsetuptopartner !== '0') && <Link to={`/${page}?id=${el.id}&type=edit`}>
                                                    <Button
                                                        onClick={() => console.log(el)}
                                                        variant={"text"}
                                                        size="small"
                                                        style={{ marginLeft: 0 }}
                                                    >
                                                        <TranslatedText text="ALL CURRENT FIELDS" />
                                                    </Button>
                                                </Link>
                                            ),
                                            width: 182
                                        },

                                        ...Object.keys(data[0]).map((key, i) => {
                                            return key !== "evalerror" && key !== "transcript" ? ({
                                                field: key,
                                                renderHeader: () => convertedHeaders[i] ? <TranslatedText text={convertedHeaders[i]} /> : key,
                                                width: maxLengths[key] === undefined ? 200 : maxLengths[key] * 15,
                                                minWidth: key.length * 14
                                            })
                                                :
                                                key == "evalerror" ?
                                                    {
                                                        field: "EVALERROR",
                                                        disableExport: true,
                                                        renderCell: (el: any) => {
                                                            const errorText = el.row.evalerror;
                                                            const getStatus = () => {
                                                                if (!errorText || errorText.trim() === "") {
                                                                    return { color: "success.main", label: "OK", icon: <CheckCircleIcon sx={{ color: "success.main" }} fontSize="small" /> };
                                                                }
                                                                if (errorText.includes("ВНИМАНИЕ") || errorText.includes("ОШИБКА") || errorText.includes("ATTENTION") || errorText.includes("ERROR")) {
                                                                    return { color: "warning.main", label: "Warning", icon: <ReportProblemIcon sx={{ color: "warning.main" }} fontSize="small" /> };
                                                                }
                                                                return { color: "info.main", label: "Message", icon: <ReportGmailerrorredIcon sx={{ color: "info.main" }} fontSize="small" /> };
                                                            };
                                                            const status = getStatus();

                                                            return (
                                                                <Box
                                                                    sx={{
                                                                        borderLeft: `4px solid ${status.color}`,
                                                                        bgcolor: "background.paper",
                                                                        boxShadow: 1,
                                                                        borderRadius: 2,
                                                                        p: 1.5,
                                                                        width: "100%",
                                                                        display: "flex",
                                                                        flexDirection: "column",
                                                                        gap: 1,
                                                                        maxHeight: 460,
                                                                        overflow: "hidden",
                                                                    }}
                                                                >
                                                                    <Box display="flex" alignItems="center" gap={0.8}>
                                                                        {status.icon}
                                                                        <Typography variant="body2" color={status.color} fontWeight="bold">
                                                                            {status.label}
                                                                        </Typography>
                                                                    </Box>
                                                                    {errorText && (
                                                                        <Box dangerouslySetInnerHTML={{ __html: decode(errorText) }} sx={{ maxHeight: 450, overflowY: "auto", maxWidth: 300 }}>

                                                                        </Box>
                                                                    )}
                                                                </Box>
                                                            );
                                                        },
                                                        width: 280
                                                    }

                                                    :

                                                    {
                                                        field: "TRANSCRIPT",
                                                        disableExport: true,
                                                        // valueFormatter: ({ value }: any) => `${value * 100}%`,
                                                        renderCell: (el: any) => {
                                                            return (el.row.transcript !== null && el.row.transcript.includes('=>') ?
                                                                <Chip sx={{
                                                                    p: '3px',
                                                                    height: 'auto',
                                                                    '& .MuiChip-label': {
                                                                        display: 'block',
                                                                        whiteSpace: 'normal',
                                                                    },
                                                                }} color="success" label={el.row.transcript.replace('=>', '')} size='small' icon={<SmartToyIcon />} />
                                                                : el.row.transcript !== null && el.row.transcript.includes('<=') ?
                                                                    <Chip sx={{
                                                                        p: '3px',
                                                                        height: 'auto',
                                                                        '& .MuiChip-label': {
                                                                            display: 'block',
                                                                            whiteSpace: 'normal',
                                                                        },
                                                                    }} color="info" label={el.row.transcript.replace('<=', '')} size='small' icon={<RecordVoiceOverIcon />} />
                                                                    :
                                                                    ''
                                                            )
                                                        },
                                                        width: 500
                                                    }
                                        })
                                    ]
                                    :
                                    page == 'settingsupconversationtemplate' ?
                                        [
                                            {
                                                field: "EDIT",
                                                disableExport: true,
                                                // valueFormatter: ({ value }) => `${value * 100}%`,
                                                renderCell: (el: any) => (
                                                    (el.row.showsetuptopartner !== '0') && <Link to={`/${page}?id=${el.id}&type=edit`}>
                                                        <Button
                                                            onClick={() => console.log(el)}
                                                            variant={"text"}
                                                            size="small"
                                                            style={{ marginLeft: 0 }}
                                                        >
                                                            <TranslatedText text="EDIT" />
                                                        </Button>
                                                    </Link>
                                                ),
                                                width: 82
                                            },
                                            {
                                                field: "COPY",
                                                disableExport: true,
                                                // valueFormatter: ({ value }) => `${value * 100}%`,
                                                renderCell: (el: any) => (
                                                    (el.row.showsetuptopartner !== '0' || accesslevel === '5') && <Link to={`/${page}?id=${el.id}&type=copy`}>
                                                        <Button
                                                            onClick={() => console.log(el)}
                                                            variant={"text"}
                                                            size="small"
                                                            style={{ marginLeft: 0 }}
                                                        >
                                                            <TranslatedText text="Copy" />
                                                        </Button>
                                                    </Link>
                                                ),
                                                width: 82
                                            },

                                            ...Object.keys(data[0]).filter((row) => row !== 'commanddetails').map((key, i) => {

                                                return ({
                                                    field: key,
                                                    renderHeader: () => convertedHeaders[i] ? <TranslatedText text={convertedHeaders[i]} /> : key,
                                                    width: maxLengths[key] === undefined ? 200 : maxLengths[key] * 15,
                                                    minWidth: key.length * 14
                                                })

                                            }),

                                            {
                                                field: "TRANSCRIPT",
                                                disableExport: true,
                                                // valueFormatter: ({ value }: any) => `${value * 100}%`,
                                                renderCell: (el: any) => {
                                                    console.log(el.row.commanddetails.split('\n'));

                                                    return (

                                                        <Stack spacing={0.5}>
                                                            {el.row.commanddetails.split('\n').map((langtext: any) => {
                                                                if (langtext != '') {
                                                                    return (
                                                                        <Chip sx={{ justifyContent: 'flex-start' }} label={langtext.slice(3)} avatar={<Avatar>{langtext.slice(0, 2)}</Avatar>} />
                                                                    )
                                                                }
                                                                else {
                                                                    return ''
                                                                }

                                                            })}
                                                        </Stack>
                                                    )
                                                },
                                            }
                                        ]
                                        :
                                        page == 'wordgroup' ?
                                            [
                                                {
                                                    field: "EDIT",
                                                    disableExport: true,
                                                    // valueFormatter: ({ value }) => `${value * 100}%`,
                                                    renderCell: (el: any) => (
                                                        (el.row.showsetuptopartner !== '0' || accesslevel == '5') && <Link to={`/${page}?id=${el.id}&type=edit`}>
                                                            <Button
                                                                onClick={() => console.log(el)}
                                                                variant={"text"}
                                                                size="small"
                                                                style={{ marginLeft: 0 }}
                                                            >
                                                                <TranslatedText text="EDIT" />
                                                            </Button>
                                                        </Link>
                                                    ),
                                                    width: 82
                                                },

                                                ...Object.keys(data[0]).filter((row) => row !== 'groupdetails' && row !== 'partner' && row !== 'conversationtemplate').map((key, i) => {
                                                    return ({
                                                        field: key,
                                                        renderHeader: () => {
                                                            if (key == 'showsetuptopartner') {
                                                                return (<TranslatedText text="ACCESS TO EDIT" />)
                                                            }
                                                            else if (key == 'conversationtemplatecode') {
                                                                return (<TranslatedText text="CONVERSATION TEMPLATE" />)
                                                            }
                                                            else if (key == 'partnerbankcode') {
                                                                return (<TranslatedText text="PARTNER" />)
                                                            }
                                                            else {
                                                                return (<TranslatedText text={key.toUpperCase()} />)
                                                            }
                                                        },
                                                        width: maxLengths[key] === undefined ? 200 : maxLengths[key] * 15,
                                                        minWidth: key.length * 14
                                                    })

                                                }),

                                                {
                                                    field: "DETAILS",
                                                    disableExport: true,
                                                    renderHeader: () => <TranslatedText text={"DETAILS"} />,
                                                    renderCell: (el: any) => {


                                                        return (

                                                            <Stack spacing={0.5}>
                                                                {
                                                                    Array.isArray(JSON.parse(el.row.groupdetails)) ? <Chip sx={{ justifyContent: 'flex-start' }} label={el.row.groupdetails} avatar={<Avatar>{'ru'}</Avatar>} />
                                                                        :

                                                                        Object.entries(JSON.parse(el.row.groupdetails)).map((langtext: any) => {
                                                                            if (JSON.stringify(langtext[1]) != '') {
                                                                                return (
                                                                                    <Chip sx={{ justifyContent: 'flex-start' }} label={JSON.stringify(langtext[1])} avatar={<Avatar>{langtext[0]}</Avatar>} />
                                                                                )
                                                                            }
                                                                            else {
                                                                                return ''
                                                                            }

                                                                        })}
                                                            </Stack>
                                                        )
                                                    },
                                                }
                                            ]
                                            :
                                            (page == 'calls' || "conversation") && !page.includes('report') && page != 'chart' && page != 'optimizationtemplate' ?
                                                [
                                                    {
                                                        field: "EDIT",
                                                        disableExport: true,
                                                        // valueFormatter: ({ value }) => `${value * 100}%`,
                                                        renderCell: (el: any) => (
                                                            <Link to={`/${page}?id=${el.id}&type=edit`}>
                                                                <Button
                                                                    onClick={() => console.log(el)}
                                                                    variant={"text"}
                                                                    size="small"
                                                                    style={{ marginLeft: 0 }}
                                                                >
                                                                    <TranslatedText text="EDIT" />
                                                                </Button>
                                                            </Link>
                                                        ),
                                                        width: 100
                                                    },
                                                    {
                                                        field: "DETAILS",
                                                        disableExport: true,
                                                        // valueFormatter: ({ value }) => `${value * 100}%`,
                                                        renderCell: (el: any) => (
                                                            el.row.uniqueid !== null && <Link to={`/conversationdetails?uniqueid=${el.row.uniqueid}`}>
                                                                <Button
                                                                    onClick={() => console.log(el)}
                                                                    variant={"text"}
                                                                    size="small"
                                                                    style={{ marginLeft: 0 }}
                                                                >
                                                                    <TranslatedText text="Details" />
                                                                </Button>
                                                            </Link>
                                                        ),
                                                        width: 82
                                                    },

                                                    ...Object.keys(data[0]).filter((row) => row !== 'commanddetails').map((key) => ({
                                                        field: key,
                                                        headerName: key.toUpperCase(),
                                                        width: maxLengths[key] === undefined ? 200 : maxLengths[key] * 15,
                                                        minWidth: key.length * 14
                                                    }))
                                                ]

                                                :
                                                [
                                                    ...Object.keys(data[0]).map((key, i) => ({
                                                        field: key,
                                                        headerName: key.toUpperCase(),
                                                        renderHeader: () => convertedHeaders[i] ? <TranslatedText text={convertedHeaders[i]} /> : key,
                                                        width: maxLengths[key] === undefined ? 200 : maxLengths[key] * 15,
                                                        minWidth: key.length * 14
                                                    }))
                                                ]}
                />
            ) : (
                <NoDataOverlay />
            )}

            <Modal
                open={openDeleteModal}
                onClose={handleDeleteModalClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={Modalstyle}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        <TranslatedText text="Delete object" />
                    </Typography>
                    <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                        <TranslatedText text="Are you sure you want to delete the object with ID" /> {openDeleteModal}?
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: "space-between", paddingTop: 2 }}>
                        <Button onClick={handleDeleteModalClose}><TranslatedText text="Cancel" /></Button>
                        <Button onClick={() => handleDelete(openDeleteModal)} color='error'><TranslatedText text="Delete" /></Button>
                    </Box>
                </Box>
            </Modal>
        </>

    )
}

export default React.memo(Table);